import React from 'react'
import { FaQuoteRight } from 'react-icons/fa'
import { motion } from 'framer-motion'
import Magazines from '../../Magazines/Magazines'
import { fadeIn, textVariant } from '../../utils/motion'
import { testimonials } from '../../Constants'
import { styles } from '../../styles'

const Testimonial = () => {
  return (
    <section className=' bg-white mt-12 dark:bg-black_100 rounded-lg pb-10 shadow-lg dark:shadow-none'>
      <section
        className={`${styles.padding} dark:bg-tertiary rounded-xl min-h-[300px]`}
      >
        <motion.div className='' variants={textVariant()}>
          <p className='sm:text-[18px] text-[14px] dark:text-secondary tracking-wider uppercase font-medium text-primary'>
            customer testimonails.
          </p>
          <h2 className='text-[#915eff] dark:text-white font-black md:text-[60px] sm:text-[50px] xs:text-[40px] text-[30px]'>
            What others say about me,
          </h2>
          <p className='mt-4 dark:text-secondary text-gray-500 text-[17px] max-w-3xl leading-[30px]'>
            I am happy when my clients are too.
          </p>
        </motion.div>
      </section>
      <div
        className={`${styles.paddingX} flex flex-row flex-wrap -mt-12 gap-3`}
      >
        {testimonials.map(
          ({ name, image, testimonial, company, designation }, i) => {
            return (
              <motion.div
                variants={fadeIn('', 'spring', i * 0.5, 1.2)}
                className={`dark:bg-black_200 bg-primary_color py-10 px-6 rounded-3xl xs:w-[320px] w-full mx-auto shadow-md dark:shadow-none`}
                key={i}
              >
                <p className='dark:text-white font-black text[48px] text-[#915eff] '>
                  <FaQuoteRight />
                </p>
                <article className='mt-1 '>
                  <p className='dark:text-white text-gray-500 tracking-wider text-[18px]'>
                    {testimonial}{' '}
                  </p>
                </article>
                <figure className='mt-7 flex justify-between items-center gap-1 '>
                  <figcaption className=''>
                    <p className='dark:text-white text-[#915eff] font-medium text-[16px] '>
                      <span className='blue-text-gradient'>@</span> {name}
                    </p>
                    <p className='mt-1 dark:text-secondary text-[12px] font-medium text-primary'>
                      {' '}
                      {designation} of {company}{' '}
                    </p>
                  </figcaption>
                  <motion.img
                    whileInView={{ scale: [0, 1] }}
                    transition={{ duration: 0.2, easings: 'ease-out' }}
                    src={image}
                    alt='person'
                    className='w-10 h-10 rounded-full object-cover shadow-lg dark:shadow-none shadow-white'
                  />
                </figure>
              </motion.div>
            )
          }
        )}
      </div>
    </section>
  )
}

export default Magazines(Testimonial, 'testimonails')
